import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { LocationService } from 'cbd-proxies';
import { WoodCertificationService } from '../proxy/geographic/controllers';

FieldBuilder.setNamespace('Geographic');

export const WOODCERTIFICATIONDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('lastCheckDate', 'Entity.WoodCertificationDetail.LastCheckDate')
    .build(),
  FieldBuilder
    .date('addedDate', 'Entity.WoodCertificationDetail.AddedDate')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'woodCertificationId',
    'Entity.WoodCertification',
    WoodCertificationService
  )
    .displayFromNested('woodCertification.name')
    .sortBy('woodCertification.name')
    .build(),
  FieldBuilder.foreignKey(
    'locationId',
    'Entity.Location',
    LocationService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('contractId', 'Entity.WoodCertificationDetail.ContractId')
    .build(),
];

export const WOODCERTIFICATIONDETAIL_CONFIG = {
  entityName: 'WoodCertificationDetail',
  localizationKey: 'Geographic::Entity.WoodCertificationDetail',
  fields: WOODCERTIFICATIONDETAIL_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
